import { SvgName } from "../../types/svg";
import { cn } from "../../utils";
import { Avatar, AvatarFallback, AvatarImage } from "./Avatar";
import { RedDot } from "./Dot";
import { Svg } from "./Svg";

type UserAvatarProps = {
  imgUrl: string;
  name?: string | null;
  className?: string;
  containerClassName?: string;
  pellet?: boolean;
  width?: number;
  fallbackName?: SvgName;
  avatarImgClassName?: string;
};

const UserAvatar = ({
  imgUrl,
  name,
  className,
  containerClassName,
  width = 32,
  fallbackName = "userFillBlue",
  pellet = false,
  avatarImgClassName,
}: UserAvatarProps) => {
  const DEFAULT_ALT = "user_avatar";
  const alt = name ?? DEFAULT_ALT;

  return (
    <div className={cn("relative inline-block", containerClassName)}>
      <Avatar className={cn(className)}>
        <AvatarImage
          src={imgUrl}
          alt={alt}
          className={avatarImgClassName}
          draggable={false}
        />
        <AvatarFallback className="bg-blue-50">
          <Svg name={fallbackName} alt={alt} width={width} />
        </AvatarFallback>
      </Avatar>
      {pellet && <RedDot className="absolute bottom-0 right-0 size-2.5" />}
    </div>
  );
};

export default UserAvatar;
